import React from "react";
import { Box } from "@mui/material";

import Typography from "../Typography";
import Chip from "../Chip";
import { useStyles } from "./ListItemCellStyles";
import { ListItemCellProps } from "./ListItemCell.types";

function ListItemCell(props: ListItemCellProps): JSX.Element {
  const {
    children,
    textColor = "lightGrey",
    size = "body3",
    subText,
    subTextComponent,
    chipText,
    chipColor,
    fontWeight = "regular",
    align = "inherit",
    borderRight,
    ...other
  } = props;

  const classes = useStyles(props);

  let tgColor: any;
  let tgTone: any;
  switch (textColor) {
    case "darkGrey":
      tgColor = "grey";
      tgTone = 900;
      break;
    case "lightGrey":
      tgColor = "grey";
      tgTone = 700;
      break;
    case "mediumGrey":
      tgColor = "grey";
      tgTone = 600;
      break;
    default:
      tgColor = textColor;
      tgTone = "main";
      break;
  }

  return (
    <Box {...other} className={classes.root} p={4}>
      <Typography
        variant={size}
        color={tgColor}
        tone={tgTone}
        noWrap={true}
        fontWeight={fontWeight}
        align={align}
        className={chipText ? classes.withChip : classes.withoutChip}
      >
        {children}
      </Typography>
      {chipText && (
        <Box display="inline" ml={2} className={classes.chip}>
          <Chip label={chipText} color={chipColor} size="small" />
        </Box>
      )}

      {subText ? (
        <Box mt={1.2}>
          <Typography color="grey" tone={600} variant="label3" display="block">
            {subText}
          </Typography>
        </Box>
      ) : (
        subTextComponent || <></>
      )}
    </Box>
  );
}

export default ListItemCell;
